import { createSlice, createAction, createEntityAdapter } from "@reduxjs/toolkit";
import { normalize, schema } from "normalizr";
import Enum from "enums-js";

export const genarateSegmentValidationAction = createAction("validationResult/genarateSegmentValidation");


const segmentValidationState = {
  unknown: 0,
  valid: 1,
  warning: 2,
  error: 3,
};

const initState = {
  validationSegments: [],
  // validated: false,
  // differentLeadingSpaces: false,
  // differentTrailingSpaces: false,
  // differentTagSpaces: false,
  // hasDoubleSpaces: false,
  // hasLineBreak: false,
  // missingTags: false,
  // differentTags: false,
  // incorrectTagOrder: false,
  // differentTagsNesting: false,
  // possibleIncorrectTagOrer: false,
  // isEmpty: false,
  // repeatedWords: false,
  // numericMismatch: false,
  // missingPeriod: false,
  // extraPeriod: false,
  // draft: false,
  // maxLengthExceeded: false,
  // placeholdersMismatch: false,
  // specialCharsMismatch: false,
  // state: segmentValidationState1,
  // targetId: 0,
  // numberOfErrors: 0,
  // numerOfWarnings: 0,
};

const validationAdapter = createEntityAdapter({
  selectId: (segment) => segment.targetId,
});

const validateSlice = createSlice({
  name: "validationResult",
  initialState: validationAdapter.getInitialState({
    loading: false,
  }),
  reducers: {
    segmentAdded: validationAdapter.addOne,
    validationLoading(state) {
      if (state.loading === false) {
        state.loading = true;
      }
    },
    validateSegment: (state, action) => {
      if (state.loading === true) {
        let result = action.payload.svr;
        result.targetId = action.payload.segmentId;
        let ifExists = state.ids.filter((id) => id == action.payload.segmentId);
        if (ifExists.length > 0) {
          validationAdapter.setOne(state, result);
        } else {
          validationAdapter.addOne(state, result);
        }
        state.loading = false;
      }
    },
    updateValidation: validationAdapter.updateOne,
  },
});
export const svrSelecto = validationAdapter.getSelectors((state) => state.validation);
export const { validateSegment, segmentAdded, validationLoading } = validateSlice.actions;

export default validateSlice.reducer;
